'use strict';

exports.__esModule = true;
exports.getFinal = getFinal;
var GET_FINAL = 'polomundial.com.ar/finals/GET_FINAL';
exports.GET_FINAL = GET_FINAL;

function getFinal(tournamentId) {
  return {
    type: GET_FINAL,
    payload: fetch('https://db.uxtemple.com/polomundialcomar/final-' + tournamentId).then(function (r) {
      return r.json();
    }),
    meta: {
      tournamentId: tournamentId
    }
  };
}